import { useResolve } from '@visiba/instantiation';
import { useConstant } from '@visiba/react-std';
import { ReactNode, useLayoutEffect, useState } from 'react';
import { Router } from 'react-router';
import { RouterService } from './router.service';

interface Props {
	basename?: string;
	children?: ReactNode;
	window?: Window;
	forceNewHistory?: boolean;
}

// Implements https://github.com/ReactTraining/react-router/blob/dev/packages/react-router-dom/index.tsx#L95

/**
 * A <Router> for use in web browsers. Provides the cleanest URLs.
 */
export function ProgrammaticBrowserRouter({ children, window, basename, forceNewHistory }: Props) {
	const routerService = useResolve(RouterService);
	const history = useConstant(() => routerService.createBrowserHistory({ window, basename }, forceNewHistory));

	const [state, setState] = useState({
		location: history.location,
	});

	useLayoutEffect(() => history.listen(setState), [history]);

	return (
		<Router location={state.location} navigator={history} basename={basename}>
			{children}
		</Router>
	);
}
